import script from "./yzdg.vue?vue&type=script&setup=true&lang=js"
export * from "./yzdg.vue?vue&type=script&setup=true&lang=js"

import "./yzdg.vue?vue&type=style&index=0&id=b04d8afc&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b04d8afc"]])

export default __exports__